import React from "react";
import ReactDOM from "react-dom/client";
import "./App.css";
import App from "./App";
import {GoogleOAuthProvider} from "@react-oauth/google";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
    >
      <App />
    </GoogleReCaptchaProvider>
  </GoogleOAuthProvider>,
);